module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_c('div', {
    staticClass: "logo"
  }, [_vm._v("\n        平台管理系统\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('el-menu', {
    ref: "menu",
    attrs: {
      "router": true,
      "theme": "none",
      "default-active": _vm.activePath
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/admin/main/index"
    }
  }, [_c('span', {
    staticClass: "home",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("首页")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/admin/main/device/list"
    }
  }, [_c('span', {
    staticClass: "coach",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("设备管理")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/admin/main/dealer/list"
    }
  }, [_c('span', {
    staticClass: "activity",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("经销商管理")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/admin/main/program/list"
    }
  }, [_c('span', {
    staticClass: "coach",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("节目管理")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/admin/main/whiteList/list"
    }
  }, [_c('span', {
    staticClass: "course",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("白名单")])]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/admin/main/manufacturer/list"
    }
  }, [_c('span', {
    staticClass: "activity",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("厂商管理")])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fdfc70ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 1214
// module chunks = 2